import { t } from 'i18next';

export default function messagingDeletedMessageLabel(isRemovedByModerator: boolean) {
  return isRemovedByModerator
    ? t('messaging.removed_by_moderator_message')
    : t('messaging.deleted_message');
}
